import {Component, Inject} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {AdminService} from "../../services/admin.service";
import {MatchStatus} from "../match-modal/match-modal.component";

@Component({
  selector: 'app-edit-game',
  templateUrl: './edit-game.component.html',
  styleUrls: ['./edit-game.component.scss']
})
export class EditGameComponent {
  match: any;
  isSaving: boolean = false;
  initiallyCompleted: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<EditGameComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private adminService: AdminService
  ) {
    this.match = { ...data.match };

    this.initiallyCompleted = this.match.status === 'FINISHED';

    if (this.match.date) {
      const localDate = new Date(this.match.date);
      this.match.gameDate = localDate.toISOString().split('T')[0];
      this.match.gameTime = localDate.toTimeString().substring(0, 5);
    }
  }

  matchStatuses = Object.values(MatchStatus);

  isSaveDisabled(): boolean {
    return this.initiallyCompleted || this.isSaving;
  }

  formatDate(dateString: string, timeString: string): string {
    const dateObj = new Date(dateString);
    let formattedTime = timeString.length === 5 ? `${timeString}:00` : timeString;
    return `${dateObj.getFullYear()}-${(dateObj.getMonth() + 1).toString().padStart(2, '0')}-${dateObj.getDate().toString().padStart(2, '0')} ${formattedTime}`;
  }

  saveChanges(): void {
    this.isSaving = true;

    const formattedDate = this.formatDate(this.match.gameDate, this.match.gameTime);

    const payload = {
      homeTeamId: this.match.homeTeamId,
      awayTeamId: this.match.awayTeamId,
      homeTeamLogo: this.match.homeTeamLogo,
      awayTeamLogo: this.match.awayTeamLogo,
      homeTeamScore: this.match.homeTeamScore,
      awayTeamScore: this.match.awayTeamScore,
      weekNumber: this.match.weekNumber,
      leagueId: this.match.leagueId,
      status: this.match.status,
      date: formattedDate
    };

    this.adminService.updatedWeekMatches(this.match.id, payload).subscribe(
      () => {
        this.isSaving = false;
        this.dialogRef.close(payload);
      },
      (error) => {
        console.error('Error updating match:', error);
        this.isSaving = false;
        alert('Failed to update match. Please try again.');
      }
    );
  }

  close(): void {
    this.dialogRef.close();
  }
}
